import { useLocation } from 'react-router'
import { CardSkeleton } from '@/components/layout/card-skeleton'
import { StaticSiteAccessLogsTabFallback } from '@/routes/static-site/tabs/access-logs/fallback'
import { OverviewTabFallback } from '@/routes/static-site/tabs/overview/fallback'

export const StaticSitePageFallback = () => {
  const location = useLocation()

  if (location.pathname.includes('/overview')) {
    return <OverviewTabFallback />
  }

  if (location.pathname.includes('/logs')) {
    return <StaticSiteAccessLogsTabFallback />
  }

  return <CardSkeleton />
}
